module.exports = __webpack_public_path__ + "img/organigramadic.6d921f65.png";